import React from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { ZOOM_CONSTANTS } from "../../../utils/appConstants";
import Button from "../../DesignSystem/button";
import { Icon } from "@iconify/react";
import Draggable from "react-draggable";

interface ZoomControlProps {
  onRangeChange: (_: any) => void;
}

const CanvasController: React.FC<ZoomControlProps> = ({ onRangeChange }) => {
  const { step } = ZOOM_CONSTANTS;
  return (
    <Draggable handle=".handle" bounds="parent">
      <div className="canvas-controller">
        <div className="range-slider no-select" data-testid="range-slider">
          <div onClick={() => onRangeChange(step)} data-testid="zoom-out">
            <RemoveIcon />
          </div>
          <div onClick={() => onRangeChange(-step)} data-testid="zoom-in">
            <AddIcon />
          </div>
        </div>
      </div>
    </Draggable>
  );
};

export default CanvasController;
